import { render, staticRenderFns } from "./Platform-Selector.vue?vue&type=template&id=1eaf2f97&lang=pug"
import script from "./Platform-Selector.vue?vue&type=script&setup=true&lang=ts"
export * from "./Platform-Selector.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports